import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Input, Row, Space, Table, Tooltip } from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';

function DieSummarySizeReport() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState('');

  const onSearchChange = e => {
    setSearchText(e.target.value);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'srNo',
      key: 'srNo',
      sorter: true,
    },
    {
      title: 'Die Size',
      dataIndex: 'dieSize',
      key: 'dieSize',
      sorter: true,
    },
    {
      title: 'No of Dies',
      dataIndex: 'diesno',
      key: 'diesno',
      sorter: true,
    },
    {
      title: 'Purchase Price',
      dataIndex: 'purchaseprice',
      key: 'purchaseprice',
      sorter: true,
    },
    {
      title: 'Total Purchase Price',
      dataIndex: 'totalPurchasePrice',
      key: 'totalPurchasePrice',
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
    },
  ];

  const data = [
    {
      key: '1',
      srNo: '1',
      dieSize: '160mm X 110mm',
      diesno: '2',
      purchaseprice: '300',
      totalPurchasePrice: '600',
      status: 'Active',
    },
    {
      key: '2',
      srNo: '2',
      dieSize: '160mm X 110mm',
      diesno: '2',
      purchaseprice: '300',
      totalPurchasePrice: '600',
      status: 'In Active',
    },
    {
      key: '3',
      srNo: '3',
      dieSize: '160mm X 110mm',
      diesno: '2',
      purchaseprice: '300',
      totalPurchasePrice: '600',
      status: 'Active',
    },
  ];

  const filteredData = data.filter(
    item =>
      item.dieSize.toLowerCase().includes(searchText.toLowerCase()) ||
      item.status.toLowerCase().includes(searchText.toLowerCase())
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  return (
    <>
      <Row className="pagenamerow" justify="space-between" align="middle">
        <Col>
          <h2 style={{ margin: 0 }}>Die Summary Size Report</h2>
          <div className="bredcrumbwrp">
            <Link to="/dashboard" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/dashboard">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Die Summary Size Report</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        <Col>
          <Row justify="space-between" align="middle" style={{ marginBottom: '20px' }}>
            <Col flex="1">
              <Input
                placeholder="Search"
                  className='searchbox'
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={onSearchChange}
                style={{ width: '100%' }}
              />
            </Col>
            <Col>
              <Space size="middle">
                <Link>
                  <Tooltip title={"Filter"}>
                    <FilterIcon style={{ height: '33px' }} />
                  </Tooltip>
                </Link>
                <Link to="/add-tool">
                  <Button type="primary" icon={<DownloadOutlined />}>
                    <Tooltip title={"Download PDF"}>
                      Download PDF
                    </Tooltip>
                  </Button>
                </Link>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={filteredData}
        scroll={{ x: 1000 }}
        rowSelection={rowSelection}
        pagination={{ pageSize: 10 }} // Adjust page size if needed
      />
    </>
  );
}

export default DieSummarySizeReport;
